import deDE from '../../translations/de-DE.json';
import enGB from '../../translations/en-GB.json';
import esES from '../../translations/es-ES.json';
import frFR from '../../translations/fr-FR.json';
import nlNL from '../../translations/nl-NL.json';

const translations = {
	'en-gb': enGB,
	'es-es': esES,
	'fr-fr': frFR,
	'nl-nl': nlNL,
	'de-de': deDE,
};

export const DEFAULT_LOCALE = 'en-gb';

/**
 * Map a stored/provided locale onto a key that definitely exists in the
 * translations map, falling back to English.
 *
 * The locale is persisted in localStorage and read back on boot, so any
 * unexpected value (wrong casing, a locale we no longer ship, manual
 * tampering) would otherwise reach `translations[locale]` as undefined and
 * crash the whole app before it renders.
 */
export function resolveLocale(locale) {
	const key = typeof locale === 'string' ? locale.toLowerCase() : '';

	return Object.prototype.hasOwnProperty.call(translations, key) ? key : DEFAULT_LOCALE;
}

export default translations;
